module.exports = __webpack_public_path__ + "img/it2.b67f8260.png";